import { ApplicationError } from '@/api/ApplicationError';

export class UnauthenticatedError extends ApplicationError {
  statusCode: number;

  constructor(message: string, statusCode: number) {
    super(message);

    this.name = 'UnauthenticatedError';
    this.statusCode = statusCode;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
